import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BudgetRequestTypeEnum } from '@zaoblako/shared/modules/task/enum/budget-request-type.enum';
import { BudgetRequestTypeEnumI18n } from '@zaoblako/shared/modules/task/i18n/budget-request-type-enum.i18n';

@Pipe({
  name: 'budgetRequestTypeName',
  standalone: true
})
export class BudgetRequestTypeNamePipe implements PipeTransform {
  public transform(type: BudgetRequestTypeEnum): string {
    return BudgetRequestTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
